import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFolderEdit: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="folder-edit, tools"><path d="M8 19.25H21.25V6.75H12L10 3.75H2.75V8.5" stroke="currentColor" strokeWidth="1.5"/><path d="M4.24414 20.0002L2.74414 18.5002L2.74414 12.2568C2.74414 11.4284 3.41571 10.7568 4.24414 10.7568C5.07257 10.7568 5.74414 11.4284 5.74414 12.2568L5.74414 18.5002L4.24414 20.0002Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconFolderEdit;
